import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(`AvailableTimeContent pad10 posRe lskyblueBg`)
}
const _hoisted_2 = { class: "appointmentContent with_white_bg pad20 rad20" }
const _hoisted_3 = { class: "posRe" }
const _hoisted_4 = { class: "fs20 fw600" }
const _hoisted_5 = { class: "fs20 fw600 arial mt4" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fs11" }, "分", -1)
const _hoisted_8 = {
  key: 0,
  class: "fs18 fw600 arial mt6"
}
const _hoisted_9 = {
  key: 1,
  class: "fs13 arial mt6"
}
const _hoisted_10 = {
  key: 2,
  class: "fs13 arial mt6"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "fs12 dgrey mt4"
}
const _hoisted_13 = { class: "fs12 fw600" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "fs14 fw600 grey arial mt5"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "fs12 dgrey mt8"
}
const _hoisted_19 = { class: "fs11" }
const _hoisted_20 = { class: "fs14 fw600" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = {
  key: 3,
  class: "fs12 arial mt6"
}
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fs11 fw600" }, "自動抽出ルール", -1)
const _hoisted_25 = { class: "fs11" }
const _hoisted_26 = {
  key: 0,
  class: "fs11"
}
const _hoisted_27 = {
  key: 0,
  class: "pointer"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 2,
  class: "pointer fs13 fw600 skyblue"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.appo)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: _normalizeClass(`fl appointmentContentInner ${_ctx.canEdit ? `withEditable` : ``} posRe`),
                style: {"width":"calc(100% - 100px)"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editAppoInfo && _ctx.editAppoInfo(...args)))
              }, [
                _createElementVNode("span", _hoisted_4, "■ " + _toDisplayString(_ctx.title || _ctx.appo.name), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                    width: "16",
                    height: "16",
                    class: "fl mr7 mt6 ml2"
                  }, null, 8, _hoisted_6),
                  _createTextVNode(" " + _toDisplayString(_ctx.appo.duration) + " ", 1),
                  _hoisted_7
                ]),
                (_ctx.startTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.appo.jp_format), 1))
                  : _createCommentVNode("", true),
                (_ctx.locationName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.locationName), 1))
                  : _createCommentVNode("", true),
                (_ctx.appo?.is_online_meeting)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.appo.online_meeting.online_meeting_url) + " ", 1),
                      _hoisted_11,
                      (_ctx.appo.online_meeting.online_meeting_account_email)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`location.online_meeting_account`)) + ": ", 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.appo.online_meeting.online_meeting_account_email), 1),
                            _hoisted_14,
                            (_ctx.appo.online_meeting.online_meeting_zoom_host_key)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _withDirectives(_createElementVNode("img", {
                                    src: _ctx.$getAssetImageUrl(`/assets/icons/key.png`),
                                    width: "18",
                                    height: "18"
                                  }, null, 8, _hoisted_16), [
                                    [_directive_tooltip, `${_ctx.$t(`location.host_key_with_no_show`)}`]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(_ctx.appo.online_meeting.online_meeting_zoom_host_key), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _hoisted_17
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.appo.online_meeting.online_meeting_password)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", null, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t(`location.passcode`)) + ":", 1),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.appo.online_meeting.online_meeting_password), 1)
                            ]),
                            _hoisted_21
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.appo.memo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.appo.memo), 1))
                  : _createCommentVNode("", true),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("div", _hoisted_25, " 日程候補提示: " + _toDisplayString(_ctx.CalendarUtil.selectDisplayMeetingTimeArr.find(
                                        mt => mt.time == (_ctx.rcm.room_setting.step_size_type || `hourly`)
                                    ).type), 1),
                      (_ctx.cm.astag && _ctx.cm.astag.can_connect_calendar && _ctx.rm.user_setting)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, " 最大提示件数: " + _toDisplayString(_ctx.rm.user_setting.auto_suggested_vote_possible_dates_max_num) + "件 ", 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(`fs16 fr appoLocation ${_ctx.canEdit ? `withEditable` : ``} posRe`),
                style: {"width":"100px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.editLocations && _ctx.editLocations(...args)))
              }, [
                (_ctx.appo.location_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createElementVNode("img", {
                        src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.appo.location_name}`, `80x80`)),
                        height: `80`,
                        width: `80`,
                        class: "fr"
                      }, null, 8, _hoisted_28)
                    ]))
                  : (_ctx.locationName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(_ctx.Util.getURLFromAddress(`${_ctx.locationName}`, `80x80`)),
                          height: `80`,
                          width: `80`,
                          class: "fr"
                        }, null, 8, _hoisted_30)
                      ]))
                    : (_ctx.canEdit)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, "場所を設定"))
                      : _createCommentVNode("", true),
                _hoisted_32
              ], 2),
              _hoisted_33
            ]),
            _hoisted_34
          ])
        ]),
        _hoisted_35
      ]))
    : _createCommentVNode("", true)
}